module.exports = __webpack_public_path__ + "static/media/Erin Cadwalader1_1667477572990.67eaab8a.jpg";